// Exports the "contextmenu" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/contextmenu')
//   ES2015:
//     import 'tinymce/plugins/contextmenu'
require('./plugin.js');


/*****************
 ** WEBPACK FOOTER
 ** ./~/tinymce/plugins/contextmenu/index.js
 ** module id = 533
 ** module chunks = 1
 **/